import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { themeClassName } from 'lib/theme/themeUtils'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const Root = styled(Pane)`
  padding: ${rem(32)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(64)} 0;
  }
`

function ContentfulIframeWrapper(props: App.ComponentIframe) {
  return (
    <Root className={themeClassName('inverse')}>
      <LayoutContainer >
        <iframe
          allow="fullscreen"
          src={props.url}
          title={props.title}
          style={{ width: '100%', height: '100vh', border: 'none' }}
          sandbox="allow-scripts allow-same-origin"
        />
      </LayoutContainer>
    </Root>
  )
}

export default ContentfulIframeWrapper
